export const main = {
	yhxm:'ユーザー名前',
	qrxx:'情報記入の確認',
    mmdl:'パスワードログイン',
    yzmdl:'認証コードログイン',
    sjhm:"携帯番号",
    qsrmm:'パスワードを入力してください',
    wjmm:'パスワードを忘れた場合',
    dl:'ログイン',
    zcxzh:'サインアップ',
    yzm:'認証コード',
    hqyzm:'確認コードを取得する',
    sryx:'メールアドレスを入力してください。',
    zcsrmm:'再度メールアドレスを入力してください。',
    yqm:'招待コード/招待者の携帯番号を入力してください',
    sjyz:'携帯認証',
    yxyz:'メール認証',
    tyxyhzc:'ユーザー規約とプライバシーポリシーに同意します',
    ty:'私は内容を読んで、同意します',
    yhxy:'ユーザー規約',
    yszc:'プライバシーポリシー',
    zce:'登録',
    zyzhljdl:'すでにアカウントをお持ちの場合は、今すぐログインしてください',
    wdzc:'私の資産',
    wdzh:'私のアカウント',
    tbgl:'同期管理',
    fbxh:'信号を発信する',
    xhsc:'信号市場',
    czsc:'マニュアル',
    tcxh:'退出信号',
    ye:'残額',
    jz:'純資産',
    jyss:'取引ロット',
    ccyl:'ポジション利益',
    xvh:'シリアルナンバー',
    sftb:'同期するか',
    fwq:'サーバー',
    zh:'アカウント',
    zyk:'総損益',
    kds:'オーダー数',
    zhzt:'アカウントステータス',
    cz:'アクセス',
    s:'はい',
    f:'いいえ',
    zc:'正常',
    yc:'異常',
    ck:'チェック',
    cpyk:'プロダクト損益',
    zss:'総ロット数',
    jypz:'取引品',
    sy:'収益',
    sszb:'ロット割合',
    cczh:'ポジション概要',
    ddh:'注文番号',
    jyl:'取引量',
    kcsj:'開始時間',
    kcjg:'開始価格',
    bjjg:'マーク価格',
    zyzs:'テイクプロフィット/ストップロス',
    gylx:'一晩の利息',
    yk:'損益',
    xzcksj:'アカウントで表示するデータを選択してください',
    tbyk:'損益同期',
    ccsj:'持ち時間',
    pcsj:'ロスカット時間',
    tjzh:'アカウント追加',
    bz:'備考',
    sfwxh:'信号かどうか',
    tbzt:'同期中',
    ytb:'同期完了',
    wtb:'未同期',
    qyjy:'有効化/無効化',
    yqy:'有効化',
    yjy:'無効化',
    xgzhmm:'パスワードを修正する',
    gbxh:'信号を閉じる',
    sczh:'アカウント削除',
    qw:'遷移',
    y:'ページ',
    tjglzh:'関連アカウント追加',
    qxz:'選択してください。',
    qsrzh:'アカウントを入力してください',
    mm:'パスワード',
    qsrbz:'備考を入力してください。',
    sjsqxhts:'リアルアカウントのマスターパスワード認証はコミュニティシグナルにアップグレード可能',
    qr:'確定',
    qx:'キャンセル',
    zhjy:'アカウント*****を無効化しますか？',
    zhqy:'アカウント*****を有効化しますか？',
    dqdlmm:'カレントパスワード',
    xzhmm:'新しいパスワード',
    qrxmm:'新しいパスワードの再確認',
    qsrdqdlmm:'カレントパスワードを入力してください。',
    qsrxmm:'新しいパスワードを入力してください。',
    qzcsrxmm:'再度新しいパスワードを入力してください。',
    yhzl:'ユーザー情報',
    jcxx:'基本情報',
    tx:'プロファイル画像',
    sczp:'写真アップロード',
    tudxxz:'アップロードする画像を選択してください: サイズ 413*626 ピクセル、サポート JPG、PNG およびその他の形式、画像は 2M 未満である必要があります。',
    gjhdq:'国と地域',
    dzyx:'メールアドレス',
    bcxg:'変更内容を保存する',
    zhaq:'アカウントのセキュリティ',
    dqmm:'カレントパスワード',
    xmm:'新しいパスワード',
    qrmm:'新しいパスワードの再確認',
    qsrdqmm:'カレントパスワードを入力してください。',
    qd:'確定',
    tjtb:'同期追加',
    tb:'同期',
    xh:'信号',
    qsrnr:'中身を入力してください。',
    tbzh:'同期アカウント',
    qxztbzh:'同期アカウントを選択してください。（複数）',
    jygz:'取引ルール',
    bzjdb:'マージン率',
    jzdb:'自己資本比率',
    kyzjdb:'利用可能資金比率',
    jyldb:'出来高比率',
    gdssdb:'固定ロット比率',
    jycs:'取引パラメータ',
    kcjybc:'初値アップの補填',
    xhsxzdpc:'シグナル障害による自動ロスカット',
    zdss:'最大手数',
    zdhc:'最大ドローダウン',
    jsbz:'すべての計算は国際標準契約に基づいています（通貨ペア国際標準契約 100,000、金国際標準契約 100 オンス、銀国際標準契約 5,000 オンス、原油国際標準契約 1,000 バレル）。',
    pctbts:'部分ロスカットとロスカットの操作は プラットフォーム端末によって、運用ルールが異なるため、同期プロセスは現在サポートされていません。',
    tbxh:'同期信号',
    tbms:'同期モード',
    tbxs:'同期係数',
    tbsz:'同期設定',
    xgcs:'パラメータ変更',
    yzttb:'同期中止',
    ykqtb:'同期開始',
    sctb:'同期削除',
    xgtbcs:'同期パラメータ変更',
    cgtbzt:'同期ステータス変更',
    sfqkzhdtb:'アカウント*******の同期を開始しますか？',
    sfztzhdtb:'アカウント*******の同期を中止しますか？',
    tjxh:'信号追加',
    nsyl:'年間収益率',
    zt:'ステータス',
    dyz:'同期者',
    kstbsj:'同期開始時間',
    zwsj:'データなし',
    xzzh:'アカウントを選択',
    qxzzh:'アカウントを選択してください。',
    qqdxhhtbzzt:'無限ループのリスクを回避するために、信号と同期者の現状を確認してください。',
    xhm:'信号名',
    qsrxhm:'信号名を入力してください。（最大15文字まで）',
    xhmts:'信号名: アカウントは一つの信号名しか持てないので、一度確定すると変更できません',
    gszzdjz:'フォロワーの最低純資産',
    sfgkxh:'信号を公開するかどうか',
    gk:'公開',
    sm:'プライベート',
    gsddzs:'注文メモに従う',
    gsddzsts:'ここに入力した内容は、すべてのフォロワーのMT注文コメントに表示されます',
    jdzyjgyhkf:'プロフェッショナル機関ユーザーのみ利用可能',
    xhms:'信号の説明',
    sl:'例: このアカウントは主に短期の日中注文用で、ストップ プロフィットとストップ ロス オーダーのみが含まれます.2,000 米ドルのロット サイズを 1:1 で同期することをお勧めします!',
    clmsts:'すべてのユーザーのプライバシーを保護するために、ポリシーの説明に連絡先情報を含めることはできません',
    xhlb:'信号リスト',
    xhlbts:'注: データは信号源のサードパーティ アカウントから取得されたものであり、データ統計は遅延または不確実である可能性があります. データは参考用であり、実際に得られる利益を表すものではありません.',
    xhy:'信号源',
    zongsyl:'総損益率',
    zhousyl:'週損益率',
    jqtjycs:'過去 7 日間の取引数',
    irrqzsy:'IRR加重利益',
    zdhc2:'最大ドローダウン (%)',
    zq:'周期（日）',
    jbsj:'基本データ',
    fx:'共有',
    sc:'お気に入り',
    ysc:'お気に入り登録',
    zsy:'総損益',
    zrj:'総預金',
    zcj:'総出金',
    zdhcl:'最大ドローダウン (値)',
    zdfk:'最大損失',
    zdds:'総オーダー数',
    dbzdjyl:'単一の最大取引量',
    t:'日',
    zhhbdw:'口座通貨単位',
    ckqb:'すべて見る',
    anyue:'月単位',
    jidu:'四半期単位',
    bannian:'半期単位',
    yinian:'1年',
    ernian:'2年',
    sanian:'3年',
    jzye:'資本/残高 ($)',
    crj:'出入金（$）',
    cj:'預金',
    rj:'出金',
    ysyl:'月次収益率',
    yiyue:'1月',
    eryue:'2月',
    sanyue:'3月',
    siyue:'4月',
    wuyue:'5月',
    liuyue:'6月',
    qiyue:'7月',
    bayue:'8月',
    jiuyue:'9月',
    shiyue:'10月',
    shiyiyue:'11月',
    shieryue:'12月',
    ccxj:'ポジション詳細',
    cq:'商品',
    dk:'ロング/ショート',
    ss:'ロット',
    yk2:'収益/損失',
    hlzb:'指標',
    ylddcxsjpj:'収益ローダーの継続期間',
    ksddcxsjpj:'損失ローダーの継続期間',
    dgddylpj:'ローダー単位の収益',
    dgddkspj:'ローダー単位の損失',
    dgddlrzd:'ローダー単位の収益',
    dgddkszd:'ローダー単位の損失',
    syl:'収益率',
    sjbl:'データ比率',
    sl:'勝率',
    zdjybl:'自動取引比率',
    pcddmx:'ロスカット明細',
    pcjg:'ロスカット価格',
    sxf:'手数料',
    tbxtccsc:'システム同期マニュアル',
    zhzc:'サインアップ',
    xtdl:'ログイン',
    jzhszwxh:'アカウントを信号に設定しますか？',
    sztbxh:'同期信号を設定する', 
    wzjs:"JCLH は、エンドユーザーにデータの集約と情報共有を提供する管理プラットフォームです。 ユーザーは、JCLH を通じてアカウントの財務とリスクを管理、分析、集計できます。 JCLH 同期システムは、複数のアカウント間の同期関係を管理する機能をユーザーに提供します。 JCLHは取引・プラットフォームではなく、いかなる金融機関とも利害関係、紹介・仲介関係はありません。",
    mzsmText:`<h1 style="text-align: center; line-height: normal;">
    <span style="color: rgb(255, 255, 255);"><span style="font-family: &quot;MS PGothic&quot;, sans-serif; font-size: 22px;">免責声明</span></span>
</h1>
<p  style=" color: windowtext; text-align: left; ">
    <span style="font-size: 12px; font-family: &quot;MS PGothic&quot;, sans-serif; color: rgb(255, 255, 255);">この声明は、JCLH と、ウェブサイト www.JCLH.biz に登録し、これらの利用規約に明示的に同意した個人または企業によって署名されています。</span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="font-size: 12px; font-family: &quot;MS PGothic&quot;, sans-serif; color: rgb(255, 255, 255);">当サイトに掲載されている情報については、細心の注意を払っておりますが、掲載されている情報がすべて正確であることを保証するものではありません。 情報が不完全で、抜けや遅れがあることをご了承ください。 このウェブサイトまたは独立した情報提供者は、情報の誤り、不完全性、遅延、不正確さ、またはこのウェブサイト上の情報への依存から生じるいかなる損失についても責任を負わないものとします。 すべての予測または意見 (将来の為替レートの変動の予測など) およびこれらの予測に基づく取引活動は、第三者の個人的な意見および行動のみを表すものであり、この Web サイトの立場を表すものではありません。 第三者による予測は、いかなる形式のパフォーマンス コミットメントも表すものではないことを理解する必要があります。直接的または間接的に従わないでください。 投資判断を行うには独自の分析を行う必要があり、このウェブサイトの内容に基づく判断に基づく投資行動が実際の利益または損失につながる可能性があることを理解する必要があります。 このウェブサイトが提供する取引戦略とシグナルに基づいて、個人構成取引システムを使用して行う投資行動は、あなた自身の決定の結果であり、すべてのリスクを負う必要があります。</span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="font-family: &quot;MS PGothic&quot;, sans-serif; font-size: 12px; color: rgb(255, 255, 255);">このウェブサイトの管理プラットフォームは、リスクの高い投資について一定の理解を持っているユーザーにのみ適しています。 日々の支出に影響を与えることなく、余剰資金を投資に使用することをお勧めします。過去の実績は将来のことを示すものではありません。 一般に、将来の為替レートの変化は予測不可能です。つまり、個人の戦略、ファイナンシャル アドバイザー、手動または自動の取引システムは、いかなる形式の予測でも利益を生み出す可能性があることを保証できないため、投資予測は独自の分析を通じて判断する必要があります。</span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="font-size: 12px; font-family: &quot;MS PGothic&quot;, sans-serif; color: rgb(255, 255, 255);">ウェブサイトまたはネットワークによる送信遅延は、データの逸脱につながる可能性があります（シグナルプロバイダーアカウントのパスワード変更またはその他のネットワーク上の理由による接続の切断で、注文追跡関係の喪失を含みますがこれらに限定されません）。同期システムでは、ユーザーはマルチアカウント管理システムのデータの変更を時間内に確認する必要があります。 JCLH およびこの Web サイトのパートナーは、JCLH が提供する情報に基づく投資および個人構成同期システムの使用が確実に利益をもたらすことを保証することはできません。 また、同期システムの開発者であるJCLHは、第三者（サービス提供会社や業者など）の遅延や過失によって生じたお客様の損失について、一切の責任を負いません。 上記に加えて、JCLH は、トレーダーが提供する戦略および取引シグナルについて一切の責任を負わないことを明確に述べています。</span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="font-size: 12px; font-family: &quot;MS PGothic&quot;, sans-serif; color: rgb(255, 255, 255);">JCLHの会社が登録されている場所の法律および規則は、他の管轄法が適用されることを指定する法律がある場合を除き、この声明およびこの声明に基づいて当事者間で生じる紛争に適用されるものとします。</span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="font-family: &quot;MS PGothic&quot;, sans-serif; font-size: 12px; color: rgb(255, 255, 255);">契約の各当事者は本声明に基づく権利を行使しよう、または本声明に基づく権利または義務を主張しようとする民事またはその他の手続きにおいて、弁護士の手数料および費用を各自負担するものとします。専属管轄権及び裁判地を承認します。</span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="font-family: &quot;MS PGothic&quot;, sans-serif; font-size: 12px; color: rgb(255, 255, 255);">この声明の解釈言語は中国語とします。</span>
</p>
<p  style=" color: windowtext; text-align: left; ">
    <span style="font-family: &quot;MS PGothic&quot;, sans-serif; font-size: 12px; color: rgb(255, 255, 255);">文書、情報、およびメッセージの非中国語と中国語の表現の間に矛盾または不一致が生じた場合、中国語の文書、情報、およびメッセージの内容を正とします。</span>
</p>
<p>
    <br/> <br/>
</p>`,
    yszcText:`<p style="font-weight: bold; color: windowtext; text-align: center; ">
    <strong>
        <span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
            隐私政策
        </span>
    </strong>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">感谢您使用 JCLH ！</span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        本《隐私政策》说明了我们如何收集、使用、处理和披露您的信息,包括与您访问和使用 JCLH 的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果本《隐私政策》中有未定义的术语（如“服务项目”或“ JCLH ”），其定义和我们在服务条款中的定义一致。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在本政策中，“ JCLH ”、“我们”或“我们的”指本《隐私政策》下对您的信息负责的 JCLH 公司。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1. 我们收集的信息类型
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        我们主要收集三类信息。
    </span>
</p>

<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        1.1 您向我们提供的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        使用 JCLH 的必要信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        当您使用 JCLH 时，我们要求您提供并收集以下您的个人信息。此等信息对于充分履行您和我们之间的合同很有必要，并使得我们能够遵守我们的法律义务。没有此等信息，我们可能无法向您提供您所要求的全部服务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.1.1 账号信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在您注册 JCLH 账号时，我们要求您提供用户昵称、手机号码、电子邮件地址、密码、头像等信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.1.2 您选择向我们提供的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以选择向我们提供额外的个人信息，以便在使用 JCLH 时获得更好的用户体验。此等额外信息将基于您的自愿同意而处理。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        额外个人资料信息。您可选择提供额外个人资料信息，作为您个人资料的一部分（例如首选语言、国家和地区及个人描述）。如您在账号设置中所示，部分此等个人信息是您公开个人资料页的一部分，将向其他人公开。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        交易风控信息。您可选择提供设置账户交易时使用的风控策略。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        其他信息。您还可以选择在填写表格、进行搜索、更新或添加 JCLH 账号信息或使用 JCLH 的其他功能时，向我们提供其他信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.2 您使用 JCLH 时，我们自动收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在您使用 JCLH 时，我们会自动收集关于您所使用的服务以及如何使用相关服务的信息，包括个人信息。 基于我们合法的利益理由以提供和改进 JCLH ，此等信息对于充分履行您和我们之间的合同很有必要，使得我们能够遵守法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        登录数据和设备信息。即使您未创建或登录 JCLH 账号，当您访问并使用 JCLH 时，我们也会自动收集登录数据和设备信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        Cookies 及类似技术。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        Log-In Cookies : 当您使用“在此计算机自动登录”的功能时，我们会使用持久 Cookies 。在这种情况下， Cookies 文件将永久的保存在您的计算机硬盘上，除非您使用浏览器或操作系统软件手工将其删除。当您再次使用该网站时，网站就会通过读取这些 Cookies，得知您的相关信息，就可以做出自动登录的动作。这些 Cookies 包含一个 ID 号。您的登录资料和您的密码不会被保存。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.3 我们通过第三方收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        第三方平台的交易账户信息。如果您将第三方交易账户连接至 JCLH，您将授权 JCLH 获取您的第三方平台的交易账户相关信息（比如:交易商信息、账户名、只读密码、交易数据等）。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        2.我们如何使用所收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们使用、存储和处理您的信息（包括个人信息），以提供、了解、改进和发展 JCLH ，创建和维护一个受到信任的、更安全的环境，并遵守我们的法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        2.1 创建和维护一个受到信任的以及更安全的环境
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        检测和预防欺诈、滥用、安全事件及其他有害活动。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        开展安全调查和风险评估。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        对照数据库与其他信息源进行检查，包括在适用法律允许的限度内以及必要时经您同意进行背景或警方调查。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        遵守我们的法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        解决我们与任何会员之间的任何争议，并执行我们与第三方的约定。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        执行我们的服务条款及其他政策。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.分享与披露
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.1 征得您的同意
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        经您同意，我们可以按照您在同意时的指示分享您的信息（包括个人信息），如当您授权第三方应用软件或网站访问您的 JCLH 账号时。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.2 业务转移
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果 JCLH 从事或涉及任何合并、收购、重组、资产出售、破产或者资不抵债的事件，那么我们可以出售、转让或分享我们的部分或全部资产，包括与此类交易或设想的此类交易(如尽职调查)有关的您的信息。在此情况下，我们会在转移您的个人信息且令其遵守不同隐私政策之前通知您。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.3汇总信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        出于遵守法规、行业与市场分析、受众统计归类、营销与广告以及其他业务目的，我们也会分享汇总信息（关于我们用户的合并信息，此类信息不再识别或指向某位个人用户）和其他匿名信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        4.其他重要信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        4.1 关联第三方账号
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您通过关联账号向我们提供的一些信息可能会被存储、处理和传输，用于欺诈防范和风险评估；以及对于您通过此类链接向 JCLH 提供的信息，其发布与显示取决于您在 JCLH 和第三方网站上的设置与授权。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.您的权利
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以联系我们，在相关 JCLH 数据控制人适用之前行使本条所述的任何权利。请注意，在对您的请求采取进一步行动之前，我们可能会要求您验证您的身份。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.1 管理您的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以通过您的账号设置访问和更新您的一些信息。您有责任及时更新您的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.2 不准确或不完整的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您有权要求我们更正您的不准确或不完整的个人信息（以及您无法在您的 JCLH 账号中自行更新的信息）。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.4 数据保留与删除
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以向官方客服申请注销帐号或删除账户信息,工作人员会在3个工作日内处理。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        通常，我们只在履行您与我们之间的合同并遵守我们的法律义务的必要时间段内保留您的个人信息。如果您不再希望我们使用您的信息来为您提供 JCLH ，您可以要求我们删除您的个人信息并关闭您的 JCLH 账号。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        请注意，如果您申请删除您的个人信息:
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们可能会保留您的一些个人信息，以符合我们的合法商业利益，如欺诈侦测和预防以及提高安全性。例如，如果我们因欺诈或安全原因停用了 JCLH 账号，则我们可能会保留该 JCLH 账号的某些信息，以防止该会员将来再次创建新的 JCLH 账号。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        为了遵守我们的法律义务，我们可能会保留并使用您的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        即使您的 JCLH 账号被注销，您与他人分享的信息仍可以在 JCLH 上公开显示。但您对这些信息的归属信息将被删除。此外，您的信息的某些副本（如登录记录）可能会保留在我们的数据库中，但会与个人标识符区分开来。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        6. 全球运营
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        为方便我们的全球运营， JCLH 可在我们的公司内部或与服务提供商转移、存储和处理您的信息。这些国家/地区的法律或许与您居住地所适用的法律不同。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        7.安全
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们将持续实施和更新管理、技术和物理安全措施，保护您的信息不受未经授权的访问、损失、破坏或变更。我们用来保护您的信息的一些安全措施是防火墙和数据加密以及信息访问控制。如果您知道或有理由相信您的 JCLH 账号信息已丢失、被盗用、被挪用或遭到其他方式入侵，或者出现任何实际或怀疑盗用您的 JCLH 账号的情况，请按照以下“联系我们”一条的说明联系我们。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        8.本《隐私政策》的变更
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        JCLH 保留随时根据本条规定修改本《隐私政策》的权利。如果我们对本《隐私政策》做出变更，我们将在 JCLH 上发布变更后的《隐私政策》，并更新《隐私政策》顶端的“最后更新”日期。如果您不同意变更后的《隐私政策》，您可以注销您的账号。如果您未在变更后的《隐私政策》生效前注销您的账号，您对 JCLH 的继续访问或使用将受变更后的《隐私政策》的约束。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        9.联系我们
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果您对本《隐私政策》或 JCLH 的信息处理方法有任何问题或意见，您可以通过官网在线客服与我们联系，或通过 JCLH 官方提供的各种联系方式与我们联系， JCLH 将给予您帮助。
    </span>
</p>
`,
fwtkText:`<h1 style="text-align: center; line-height: normal; text-indent: 0em;">
<span style="font-size: 22px;"><strong><span style="color: rgb(255, 255, 255); font-family: 微软雅黑;">服务条款</span></strong></span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;"><span>欢迎您使用</span> JCLH 网站的服务。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您应当阅读并遵守《 JCLH 服务条款》(以下简称“本协议”)，请您务必审慎阅读、充分理解各项条款内容。除非您已充分阅读、完全理解并接受本所有条款内容，否则您无权使用 JCLH 服务。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">本协议是由 JCLH 与在网站 www.JCLH.biz 上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统可以让您实现在云端管理多平台。用户可以通过JCLH管理、分析和汇总账户财务和风险。系统允许用户通过“Copy-Trading”的方式进行跨平台订单复制。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH不是不是经纪商或交易商，也不与任何金融机构有利益、介绍或居间关系。公司专注服务被传统金融市场忽略的一大部分客户:中小企业，个人客户。我们通过技术，让资产集合、风险管理、多账户管理、策略开发成为容易上手的业务。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">风险协议</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.考虑到交易存在巨大的风险，建议您在开户及交易前充分了解相关法律条规及咨询专业意见，根据个人的财务状况、投资经验、风险偏好等相关因素，慎重选择适合您的保证金交易产品。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 网站上所有信息（含文字、图片、音频、视频）均出于为公众传播有益资讯信息之目的，并不意味着 JCLH 赞同其观点或构成投资建议，且 JCLH 不会向您提供任何可依赖的投资建议。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.投资市场存在的风险是不受 JCLH 控制或影响的，您所有的交易均由个人承担风险。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">业绩统计服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您应当理解，实际投资交易的收益/亏损百分比会随着各项因素而发生变化，如初始账户余额、市场行为、跟随者的账户设置等。因此，您在进行投资过程中实际产生的收益/亏损百分比可能与JCLH 多账户管理平台中信号提供者收益/亏损百分比存在一定的差异。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 不保证您所使用的信号提供者信号或本网站所传播的信息能让您获得利润而不亏损，您在 JCLH 多账户管理平台上进行保证金投资的实际收益/亏损均由您本人承担， JCLH 不承担任何相关责任。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">网上风险服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您理解并同意，使用互联网的交易服务存在一些风险，包括硬件、软件或互联网连接等不可控因素，如信号强度、互联网的接收或路径、设备硬件或软件配置、或互联网连接的可靠性等不可控。 JCLH 不对网络交易中出现的通讯故障、误传或延误造成的损失负任何责任。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.贵金属等全球金融产品投资市场的波动性或非流动性可能阻碍委托以有利的价格执行，或根本无法执行。如因市场情况或您的交易商的过错而导致交易无法执行，从而造成的任何损失、损害、成本或费用</span>(<span>包括但不限于，利润损失、使用损失、直接、间接、偶发或结果性损害</span>)<span>，</span> JCLH <span>不承担任何责任。</span></span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">外部链接服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您理解并同意，通过 JCLH 网站链接到其他某些网站仅出于便利而提供。因这些网站所含的信息资料不可控制， JCLH 不对这些网站或您在这些网站找到的资料作出任何承诺。 JCLH 通往这些网站的链接信息，并不构成任何类型的认可或建议。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">适用法律和管辖权</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.JCLH所属公司注册所在地法律、法规应适用于本协议以及管辖本协议各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.在合约一方寻求实现本协议下的权利，或寻求宣告本协议下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.本协议的解释语言应为（简体）中文。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">4.如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">其他</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">如果您对本条款有意见或建议，可与 JCLH 客服联系， JCLH 将给予您帮助。</span>
</p>
<p>
<br/>
</p>`,
    mzsmbt:"免責声明",
	mzsmbt:"免責事項",
	qwzxcz:"アカウントトラッキングの収益を保証するために、自分で操作しないでください!",
	wdzl:"私の資料",
	wdqb:"私の財布",
	hyfw:"会員サービス",
	wdtd:"私のチーム",
	tcdl:"ログオンを終了する",
	xhgl:"信号管理",
	sfgz:"料金ルール:資金と信号資金1:1を基礎とした価格設定、ユーザー購読料は動的に更新され、日によって控除されます。",
	jcdyf:"基礎購読料",
	yhdyf:"ユーザー購読料",
	zhye:"口座残高",
	xhye:"信号残高",
	yf:"月",
	bkxzjygz:"現在選択できない取引ルール",
	bksrjycs:"現在は取引パラメータを入力できません",
	hand:"手",
	pcjl:"平倉記録",
	tdxx:"チーム情報",
	wdyqm:"私の招待コード",
	fz:"コピー",
	yqmsjh:"お薦め招待コード/携帯番号",
	bangd:"バインド",
	Magree:"同意します",
	mzsm:"免責声明",
	and:"和",
	fwtk:"サービス条項",
	qhyy:"言語を切り替える",
	zhong:"中国語",
	ying:"英語",
	wei:"維語",
	tai:"タイ語",
	han:"韓国語",
	ri:"日本語",
		
	kyye:"利用可能JCLHain残高",
	yets:"JCLHainはトークンであり、JCLHコミュニティでのみ使用でき、ユーザー間では譲渡できず、償還できない。JCLHが運営している。ポイントを購入して交換することで得られます。JCLHainは、購読料の支払い、賞品の交換、その他の駅構内行為に使用できます。詳細はJCLHain購入と使用プロトコル」を参照してください。",
	zffs:"支払い方法",
		
	szhb:"デジタル通貨",
	wxzf:"ウィーチャットペイ",
	zfb:"アリペイ",
	yl:"銀聯",
	xyk:"クレジットカード",
	szjl:"収支記録",
		
	szsj:"時間",
	szsl:"数量",
	szxm:"プロジェクト",
	szzt:"オーダーステータス",
	szbh:"注文番号",
		
	dqdj:"現在の等級",
	yxq:"有効期間至",
	shengj:"アップグレード",
	hygm:"JCLH会員へようこそ",
	zfje:"支払金額",
	xfjl:"消費記録",
	xfje:"金額",
	dzgl:"関連付け",
	dzg:"つ",
	dzzh:"アカウント",
	
	a1:'購入数量',
	a2:'会員ランク',
	a3:'アカウント数',
	a4:'操作',
	a5:'アップロード待ち証憑',
	a6:'支払い成功',
	a7:'支払い失敗',
	a8:'証憑アップロード',
	a9:'支払い確認',
	a10:'支払い',
	a11:'デジタル通貨',
	a12:'ウォレットアドレス',
	a13:'アドレスコピー',
	a14:'支払いのためウォレットアドレスをコピー',
	a15:'QR コード',
	a16:'金額',
	a17:'確認',
	a18:'キャンセル',
	a19:'閉じる',
	a20:'コピー成功',
	a21:'証憑アップロード',
	a22:'証憑確認',
	a23:'審査待ち',
	
	a24:'証拠金割合',
	a25:'純価値割合',
	a26:'使用可能資金割合',
	a27:'取引量割合',
	a28:'固定ロット数割合',
	a29:'逆方向コピートレーディング',
	a30:'ポジションオープン補償',
	a31:'ポジションクローズ補償',
	a32:'選択済み',
	a33:'現在のアカウント を有効化するかどうか',
	a34:'現在のアカウント を一時停止するかどうか',
	a35:'同期操作',
	a36:'一つのアカウントに限定',
	a37:'購入するアカウントの数に制限なし',
	
	a38:'試用版会員',
	a39:'基本版会員',
	a40:'プロフェッショナル版会員',
	a41:'機関版会員',
	a42:'携帯電話番号を設定してください',
	a43:'メールアドレ스를設定してください',
	a44:'招待コードを入力してください',
	a45:'アップロードするアバター画像は JPG 形式のみです！',
	a46:'アップロードするアバター画像のサイズは 2MB を超えてはいけません！',
	a47:'同期データは現在ありません',
	a48:'総ロット数',
	a49:'それを～に設定するかどうか',
	a50:'有効化',
	a51:'無効化',
	a52:'ステータス',
	a53:'このアカウントを削除することを確認しますか？',
	a54:'コピーしました！',
	
	a55:'取引パラメーターを入力してください',
	a56:'新しいパスワードと確認パスワードが一致しません！',
	a57:'日収益',
	a58:'平均',
	a59:'最大',
	a60:'リフレッシュ成功',
	a61:'生産性',
	a62:'基準不達',
	a63:'基準達成',
	a64:'勝率',
	a65:'出金',
	a66:'入金',
	a67:'残高',
	a68:'純資産額',
	a69:'日損益',
	a70:'数値を入力してください',
	a71:'このシグナルにはまだ同期者がいません',
	
	a72:'ログイン状態が期限切れとなりました。再度ログインしてください！',
	a73:'SMS を送信しました。確認して受け取ってください。',
	a74:'認証コードを送信しました！',
	a75:'ログイン成功です！',
	a76:'ユーザー名前は空にできません',
	a77:'携帯電話番号は空にできません',
	a78:'ユーザー契約とプライバシーポリシーに同意していません',
	a79:'会員アップグレード',
	a80:'タイプ選択',
	a81:'現在の有効期間～まで',
	a82:'換算有効期間～まで',
	a83:'注：換算後の有効期間はシステムが自動的に計算して得られたものです。',
	a84:'ファイルをここにドラッグしてください',
	a85:'または',
	a86:'クリックしてアップロード',
	a87:'お客様は既に最高グレードの会員ですので、これ以上アップグレードすることはできません。',
	a88:'審査中',
	a89:'この支払い方法は一時的にサポートしていません',
	a90:'パスワードリセット',
	a91:'思い出しました',
	a92:'アメリカ合衆国',
	a93:'中国',
	a94:'香港',
	
	a95:'リスク警告',
	a96:'本スマートクオンタコミュニティは、主に標準化された取引シグナルを提供し、ユーザーが参考して使用するものです。	',
	a97:'戦略の有効性を確保し、実行偏差を制御するため',
	a98:'単一クオンタニティ対象の資金規模は 20000 USD 以上であることを推奨します',
	a99:'投入資金がこの基準を下回る場合、資金規模の不足により相対的リスクが拡大し、戦略の安定性に影響を与える可能性があります。',
	a100:'いかなる操作を開始する前に、必ず自身の財務状況とリスク許容度に基づいてください。',
	a101:'アカウントのリスク保護メカニズムを自ら設定してください。',
	a102:'すべてのクオンタニティ取引行為は、あなたの個人の独立した意思決定によるものであり、関連する損益や、市場変動、システム障害、政策変更などの不可抗力要因によって生じた損失は',
	a103:'すべてあなた自身が負担するものです。',
	a104:'本コミュニティが提供するシグナルは、情報参考のみを目的としています。',
	a105:'投資アドバイス、オファーまたは保証を構成するものではありません。',
	a106:'本スマートクオンタコミュニティは',
	a107:'いかなる取引結果または資金損失に対する責任も負いません。',
	a108:'上記のリスクを十分に理解し、受け入れを確認した上で、操作を行ってください。',
	a109:'私は既に理解しました',
	
	zhlb:'アカウントリスト',
	
	a110:'まだランクなし',
}
